import Vue from 'vue'
import Router from 'vue-router'

import { apiIsUserAdmin, apiGetCurrentUser } from '@/services/firebase'

import { freeVersion } from './constants'
import { hasPartnerFeature, FEATURE } from '@/config/partnerFeatureFlags'

import store from '@/store'

Vue.use(Router)

console.log('::: [DEBUG] BASE_URL:', process?.env?.BASE_URL || '[ERROR]')

const myRouter = new Router({
  mode: 'history',
  base: process?.env?.BASE_URL || '/',
  routes: [
    //
    // PÁGINA DE LOGIN
    //

    {
      name: 'Login',
      path: '/login',
      component: () => import('@/sosgestor/pages/public/Login'),
    },

    //
    //
    //

    {
      path: '/',
      component: () => import('@/sosgestor/pages/general/layout'),
      children: [
        //
        //
        //

        {
          redirect: '/login',
          path: '',
        },

        //
        //
        //

        {
          name: 'Convite para Grupo',
          path: 'convite-grupo/:groupID/:invitationCode',
          component: () => import('@/sosgestor/pages/public/JoinGroup'),
          meta: {
            openToAllVisitors: true,
          },
        },

      ],
    },

    //
    // PLANTÕES DA ESCALA (LINK PÚBLICO)
    //

    {
      name: 'Ver escala através de link (Não autorizado)',
      path: '/escala/link/:groupID/:scaleID',
      component: () => import('@/sosgestor/pages/public/ShareViewScale'),
      meta: {
        openToAllVisitors: true,
      },
    },

    {
      name: 'Ver escala através de link',
      path: '/escala/link/:groupID/:scaleID/:scaleCode',
      component: () => import('@/sosgestor/pages/public/ShareViewScale'),
      meta: {
        openToAllVisitors: true,
      },
    },

    {
      name: 'Ver escala através de link',
      path: '/escala/:token',
      component: () => import('@/sosgestor/pages/public/PersonalizedShareViewScale'),
      meta: {
        openToAllVisitors: true,
      },
    },

    //
    // PLANTÕES DO GRUPO (LINK PÚBLICO)
    //

    {
      name: 'Ver plantões do grupo através de link (Não autorizado)',
      path: '/plantoes/link/:groupID',
      component: () => import('@/sosgestor/pages/public/ShareGroupShifts'),
      meta: {
        openToAllVisitors: true,
      },
    },

    {
      name: 'Ver plantões do grupo através de link',
      path: '/plantoes/link/:groupID/:groupShareCode',
      component: () => import('@/sosgestor/pages/public/ShareGroupShifts'),
      meta: {
        openToAllVisitors: true,
      },
    },
    {
      name: 'Ver plantões do grupo através de link personalizado',
      path: '/grupo/:token',
      component: () => import('@/sosgestor/pages/public/PersonalizedShareViewGroupShifts'),
      meta: {
        openToAllVisitors: true,
      },
    },

    //
    // REDEFINIR SENHA VIA LINK (E-MAIL)
    //

    {
      name: 'Redefinir Senha',
      path: '/reset-password/:token',
      component: () => import('@/sosgestor/pages/public/ResetPassword'),
      meta: {
        openToAllVisitors: true,
      },
    },

    //
    //
    //

    {
      path: '/admin',
      component: () => import('@/sosgestor/pages/logged/layout'),
      children: [
        //
        // LISTA DE GRUPOS
        //

        {
          name: 'Grupos',
          path: 'grupos',
          component: () => import('@/sosgestor/pages/logged/GroupsList'),
          meta: {
            requiresAuth: true,
          },
        },

        //
        // CRIAR GRUPO
        //

        {
          name: 'Criar Grupo',
          path: 'grupos/criar',
          component: () => import('@/sosgestor/pages/logged/CreateGroup'),
          meta: {
            requiresAuth: true,
          },
        },

        //
        // EDITOR DE USUÁRIOS
        //

        {
          name: 'Usuários',
          path: 'usuarios',
          component: () => import('@/sosgestor/pages/logged/EditorDeUsuarios'),
          meta: {
            requiresAuth: true,
            // paidOnly: true,
          },
        },

        //
        // PERFIL
        //

        {
          name: 'Minha Conta',
          path: 'perfil',
          component: () => import('@/sosgestor/pages/logged/Profile'),
          meta: {
            requiresAuth: true,
          },
        },

        //
        // ASSINATURA
        //

        {
          name: 'Assinatura',
          path: 'assinatura',
          component: () => import('@/sosgestor/pages/logged/UserSubscription'),
          meta: {
            requiresAuth: true,
            paidOnly: true,
          },
        },

        //
        // CENTRAL DE NOTIFICAÇÕES (feature flag: VUE_APP_PARTNER)
        //

        ...(hasPartnerFeature(FEATURE.NOTIFICATION_CENTER) ? [{
          name: 'Central de Notificações',
          path: 'central-de-notificacoes',
          component: () => import('@/sosgestor/pages/logged/NotificationCenter'),
          meta: {
            requiresAuth: true,
          },
        }] : []),

        //
        //
        //
        // TELAS DENTRO DE UM GRUPO
        //
        //
        //

        //
        // GRUPO
        //

        {
          name: 'Escalas',
          path: 'grupos/:groupID/escalas',
          component: () => import('@/sosgestor/pages/logged/Group'),
          meta: {
            requiresAuth: true,
            requiresGroupPrivilege: true,
          },
        },

        //
        // CONVIDAR USUÁRIO(S)
        //

        {
          name: 'Convidar',
          path: 'grupos/:groupID/convidar',
          component: () => import('@/sosgestor/pages/logged/GroupInvite'),
          meta: {
            requiresAuth: true,
            requiresGroupPrivilege: true,
          },
        },

        //
        // EDITAR ESCALA
        //

        {
          name: 'Editar Escala',
          path: 'grupos/:groupID/escalas/:scaleID/editar',
          component: () => import('@/sosgestor/pages/logged/EditScale'),
          meta: {
            requiresAuth: true,
            requiresGroupPrivilege: true,
          },
        },

        //
        // VER ESCALA
        //

        {
          name: 'Ver Escala',
          path: 'grupos/:groupID/escalas/:scaleID',
          component: () => import('@/sosgestor/pages/logged/ViewScale'),
          meta: {
            requiresAuth: true,
            requiresGroupPrivilege: true,
          },
        },

        //
        // HISTÓRICO DE PLANTÕES APAGADOS
        //

        {
          name: 'Histórico de Plantões Apagados',
          path: 'grupos/:groupID/plantoes-apagados',
          component: () => import('@/sosgestor/pages/logged/DeletedDutiesHistory'),
          meta: {
            requiresAuth: true,
            requiresGroupPrivilege: true,
          },
        },

        //
        // PLANTÕES DO USUÁRIO
        //

        {
          name: 'Usuário do grupo',
          path: 'grupos/:groupID/usuario/:userID/plantoes',
          component: () => import('@/sosgestor/pages/logged/GroupUserShifts'),
          meta: {
            requiresAuth: true,
            requiresGroupPrivilege: true,
          },
        },

        //
        // PLANTÕES DO GRUPO
        //

        {
          name: 'Ver Todos Os Plantões',
          path: 'grupos/:groupID/plantoes',
          component: () => import('@/sosgestor/pages/logged/ViewGroupShifts'),
          meta: {
            requiresAuth: true,
            requiresGroupPrivilege: true,
          },
        },

        //
        //
        //
        // CRIADOR DE SÉRIES
        //
        //
        //


        //
        // LISTA DE SÉRIES
        //

        {
          name: 'Séries',
          path: 'series',
          component: () => import('@/sosgestor/pages/logged/Series'),
          meta: {
            requiresAuth: true,
          },
        },


        //
        // CRIAR SÉRIE
        //

        {
          name: 'Série de itens',
          path: 'series/form/:id?',
          component: () => import('@/sosgestor/pages/logged/Series/form'),
          props: true,
          meta: {
            requiresAuth: true,
          },
        },

        {
          name: 'Série de itens no grupo',
          path: 'series/:groupId/form',
          component: () => import('@/sosgestor/pages/logged/Series/form'),
          props: true,
          meta: {
            requiresAuth: true,
          },
        },

        {
          name: 'Série de itens no grupo',
          path: 'series/:groupId/form/:id?/copiar',
          component: () => import('@/sosgestor/pages/logged/Series/form'),
          props: true,
          meta: {
            requiresAuth: true,
          },
        },

        //
        //
        //
        // ROTAS SUPER ADMINISTRATIVAS
        //
        //
        //

        //
        // GRUPO
        //

        {
          name: 'Super Admin Escalas',
          path: 'supadgroups/:groupID/escalas',
          component: () => import('@/sosgestor/pages/logged/Group'),
          meta: {
            requiresAuth: true,
          },
        },

        //
        // CONVIDAR USUÁRIO(S)
        //

        {
          name: 'Super Admin Convidar',
          path: 'supadgroups/:groupID/convidar',
          component: () => import('@/sosgestor/pages/logged/GroupInvite'),
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },

    //
    //
    //

    {
      path: '*',
      component: () => import('@/sosgestor/pages/general/layout'),
      children: [
        {
          name: 'Página não encontrada',
          path: '',
          component: () => import('@/sosgestor/pages/general/PageNotFound'),
        },
      ],
    },
  ],
})

myRouter.beforeEach(async (to, from, next) => {
  const firebaseCU = apiGetCurrentUser()
  const stateCU = store.state.app.userSession

  const loggedIn = stateCU.loggedIn ? stateCU.loggedIn : (!!firebaseCU === true)
  const userID = stateCU.loggedIn ? stateCU.uid : (!!firebaseCU === true && Object.prototype.hasOwnProperty.call(firebaseCU, 'uid') ? firebaseCU.uid : '')

  // [24/01/25] console.log(`::: MOVENDO DA ROTA "${from.path}" PARA "${to.path}":`, userID, loggedIn)

  /* VERIFICA SE É ADMIN */
  const requiresGroupPrivilege = to.matched.some(record => record.meta.requiresGroupPrivilege)
  const groupID = requiresGroupPrivilege ? to.params.groupID : false

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const openToAllVisitors = to.matched.some(record => record.meta.openToAllVisitors)
  const paidOnly = to.matched.some(record => record.meta.paidOnly)

  // console.log('beforeEach[rota]:', from, to)
  // console.log('beforeEach[store]:', store.state.app.userSession)

  /**
   *
   * O SISTEMA NÃO DEPENDE APENAS DO "onAuthStateChanged" PARA MANTER O VUEX ATUALIZADO COM AO STATUS ATUAL DA SESSÃO
   *
   * [20/01/25] Descoberto nas melhorias da tela de convite.
   *
   * [20/01/25] CENÁRIO DA DESCOBERTA:
   *
   * - Voltei (botão voltar do navegador sem F5) para a tela de convite após um LOGOUT ou LOGIN (que redirecionou a tela de convite para outra tela) e
   *   a tela ficava "CARREGANDO..." e não mudava.
   *
   */

  const authenticated = !!firebaseCU === true && !!firebaseCU.email === true && !!firebaseCU.uid === true

  store.dispatch('setAuthState', {
    sosOrigin: 'ROUTER',
    authenticated,
    uid: authenticated ? firebaseCU.uid : '',
    email: authenticated ? firebaseCU.email : '',
    token: authenticated ? await firebaseCU.getIdToken() : '',
    user: firebaseCU,
  })

  /**
   *
   * TRATA NAVEGAÇÃO PARA A LISTA DE GRUPOS
   *
   */

  if ((from.path !== '/admin/grupos/' && to.path === '/admin/grupos/') || (from.path !== '/admin/grupos' && to.path === '/admin/grupos')) {
    // [24/01/25] console.log('::: ENTROU NA LISTA DE GRUPOS >>> startUserGroupsListeners')
    store.dispatch('startUserGroupsListeners')
  }

  if ((from.path === '/admin/grupos/' && to.path !== '/admin/grupos/') || (from.path === '/admin/grupos' && to.path !== '/admin/grupos')) {
    // [24/01/25] console.log('::: SAIU DA LISTA DE GRUPOS >>> stopUserGroupsListeners')
    store.dispatch('stopUserGroupsListeners')
  }

  /**
   *
   * TRATA A PÁGINA DE CONVITE
   *
   */

  if (to.params && to.params.groupID) {
    // ENTROU NA PÁGINA DE CONVITE APÓS CRIAR UM GRUPO
    if (from.path === '/admin/grupos/criar' && to.path === ('/admin/grupos/' + to.params.groupID + '/convidar')) {
      // [24/01/25] console.log('::: ENTROU NA PÁGINA DE CONVITE APÓS CRIAR UM GRUPO')
      store.state.app.groupCreationStep = 'options_create'
    }

    // ENTROU NA PÁGINA DE CONVITE DIRETAMENTE OU APÓS UM RELOAD
    if (from.path === '/' && to.path === ('/admin/grupos/' + to.params.groupID + '/convidar')) {
      // [24/01/25] console.log('::: ENTROU NA PÁGINA DE CONVITE DIRETAMENTE OU APÓS UM RELOAD')
      store.state.app.groupCreationStep = 'options_invite'
    }
  }

  if (from.params && from.params.groupID && to.params && to.params.groupID) {
    // ENTROU NA PÁGINA DE CONVITE À PARTIR DA LISTA DE ESCALAS DO GRUPO
    if (from.path === ('/admin/grupos/' + from.params.groupID + '/escalas') && to.path === ('/admin/grupos/' + to.params.groupID + '/convidar')) {
      // [24/01/25] console.log('::: ENTROU NA PÁGINA DE CONVITE À PARTIR DA PÁGINA DE UM GRUPO')
      store.state.app.groupCreationStep = 'options_invite'
    }
  }

  /**
   *
   * TRATA AS ROTAS
   *
   */

  if (to.path === '/404' || openToAllVisitors || !requiresAuth || (paidOnly && freeVersion))
  {
    // [24/01/25] if (to.path === '/404') console.log('::: MOVENDO PARA A ROTA 404')
    // [24/01/25] if (openToAllVisitors) console.log('::: ESSA ROTA É PÚBLICA')
    // [24/01/25] if (!requiresAuth) console.log('::: ESSA ROTA NÃO REQUER AUTENTICAÇÃO')
    // [24/01/25] if (paidOnly && freeVersion) console.log('::: ESSA ROTA É RESTRITA PARA ASSINANTES, MAS O GESTOR ESTÁ NO MODO GRATUÍTO')

    next()
  }
  else if (!loggedIn && to.path !== '/login')
  {
    // chega aqui se for requiresAuth === true
    // [24/01/25] console.log('::: VOCÊ NÃO ESTÁ LOGADO, MOVENDO PARA A TELA DE LOGIN...')
    if (hasPartnerFeature(FEATURE.NOTIFICATION_CENTER)) store.dispatch('notifications/stopPolling')
    next('/login')
  }
  else
  {
    // Inicia polling de notificações quando groups ficam disponíveis (qualquer rota autenticada)
    if (hasPartnerFeature(FEATURE.NOTIFICATION_CENTER) && !store.state.notifications.isPolling && !store._notificationWatchStarted) {
      store._notificationWatchStarted = true
      const unwatch = store.watch(
        (state) => state.app.groups,
        (groups) => {
          if (!groups || groups.length === 0) return
          if (store.state.notifications.isPolling) return

          const groupIDs = groups.map(g => g.groupID).filter(Boolean)
          if (groupIDs.length > 0) {
            store.dispatch('notifications/fetchNotifications', groupIDs)
            store.dispatch('notifications/startPolling', groupIDs)
            unwatch()
          }
        },
        { immediate: true }
      )
    }

    if (requiresGroupPrivilege)
    {
      /* console.log('::: ESSA ROTA REQUER PRIVILÉGIOS DE GESTOR, VERIFICANDO...', userID, groupID) */

      const admin = await apiIsUserAdmin(userID, groupID)

      if (admin) {
        // [24/01/25] console.log('::: ESSA ROTA REQUER PRIVILÉGIOS DE GESTOR: PERMITIDO')
        next()
      } else {
        // [24/01/25] console.log('::: ESSA ROTA REQUER PRIVILÉGIOS DE GESTOR: NÃO PERMITIDO')
        next('/admin/grupos')
      }
    }
    else
    {
      // [24/01/25] console.log('::: MOVENDO PARA A ROTA...')
      next()
    }
  }
})

export default myRouter
